import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVectorAnchorPointStraight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVectorAnchorPointStraight"><Circle cx="12" cy="7.5" r="3" stroke="currentColor"/><Path d="M2.5 17.5L9.75 9.75" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 17.5L14.25 9.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVectorAnchorPointStraight;
